import { render, staticRenderFns } from "./ChangeRegistrationRangeModal.vue?vue&type=template&id=0b4efa2b"
import script from "./ChangeRegistrationRangeModal.vue?vue&type=script&lang=js"
export * from "./ChangeRegistrationRangeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports